import React from 'react';
import { Form, Input } from 'antd';
import useFormInstance from 'antd/lib/form/hooks/useFormInstance';

interface LocalizedFieldProps {
  name: string;
  label?: string;
  supportedLanguages: string[];
  inputType?: 'input' | 'textarea';
  placeholder?: string;
  required?: boolean;
  minLabelWidth?: number;
}

export const LocalizedField: React.FC<LocalizedFieldProps> = ({
  name,
  label,
  supportedLanguages,
  inputType = 'input',
  placeholder,
  required,
  minLabelWidth = 50,
}) => {
  return (
    <Form.Item label={label} required={required}>
      {supportedLanguages.map((lang) => (
        <div key={lang} style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ minWidth: minLabelWidth, fontWeight: 500, marginRight: 8 }}>
            {lang.toUpperCase()}
          </div>
          <Form.Item
            key={lang}
            name={[name, lang]}
            label={lang.toUpperCase()}
            rules={[{ required: false }]}
            noStyle
          >
            {inputType === 'textarea' ? (
              <Input.TextArea
                placeholder={placeholder || `Enter ${label} in ${lang}`}
              />
            ) : (
              <Input
                placeholder={placeholder || `Enter ${label} in ${lang}`}
              />
            )}
          </Form.Item>
        </div>
      ))}
    </Form.Item>
  );
};
